document.addEventListener("DOMContentLoaded", function() {
    let locationField = document.getElementById("input_1_8");
    if (locationField) {
        let apiKey = "c42f668f461f5a";

        fetch(`https://ipinfo.io/json?token=${apiKey}`)
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data && data.country) {
                    locationField.value = data.country;
                    // console.log(data.country);
                } else {
                }
            })
            .catch(error => console.log("Error fetching location:", error));
    } else {

    }
});